/* eslint-disable */
import React from "react";
import { SmartImg } from "./utils";
import styles from "./ExportModal.module.css";

const CHECK = <svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5" /></svg>;
const GLASSES = <svg viewBox="0 0 24 24"><circle cx="6" cy="14" r="4" /><circle cx="18" cy="14" r="4" /><path d="M10 14h4M2 12l2-2M22 12l-2-2" /></svg>;

// One selectable original row in the export selection list.
export function ExportItemRow({ item, selected, onToggle, statusColor }) {
  const img = (item.images || [])[0];
  const meta = [item.sku || "no SKU", item.shape1 || item.shape, item.gender]
    .filter(Boolean).join(" · ");
  const clr = statusColor(item.status);
  return (
    <div className={`${styles.row} ${selected ? styles.rowSel : ""}`} onClick={onToggle}>
      <span className={`${styles.check} ${selected ? styles.checkOn : ""}`}>
        {selected && CHECK}
      </span>
      <span className={styles.thumb}>
        {img ? <SmartImg src={img} displayWidth={64} alt="" /> : <span className={styles.thumbPh}>{GLASSES}</span>}
      </span>
      <span className={styles.rowInfo}>
        <span className={styles.rowBrand}>{item.brand || item.model || "—"}</span>
        <span className={styles.rowMeta}>{meta}</span>
      </span>
      {item.status && (
        <span className={styles.statusTag} style={{ color: clr, background: clr + "18" }}>
          {item.status}
        </span>
      )}
    </div>
  );
}
